module.exports = __webpack_public_path__ + "static/x53-64739c12c6d68b37aa9de981ed8ffdb8.png";